'use client'

// The job centre's front (Sam, 30 Oct): over buildings_25's shutters, between City Mags and the community workshop, the
// glass front of a shop with job notices in the window, the green banner across the top of the opening, and the square
// sign sticking out on its bracket above. Laid out in the blend at world coordinates (collection JobCentre, apart from
// Buildings, so a buildings export never carries it), its own file like the taco truck, one texture (KTX2), one draw.
// Shown only once the town says the job centre is open (sim-server TUNABLES.jobCentreEnabled, read through /api/jobs):
// until then the shutters stay down.

import { useEffect, useState } from 'react'
import { useSceneNodeMaterials } from '../hooks/useSceneNodeMaterials'
import { useModel } from '../hooks/useModel'

const MODEL = '/models/jobCentre.glb'
const READ_MS = 5 * 60_000

// (loaded with the rest of the town and compiled behind the veil, and only shown once it is open: mounted later, the
// first time the board said open, it set the precompiler's state while it rendered)
export function JobCentre() {
  const { scene } = useModel(MODEL)
  useSceneNodeMaterials(scene, { roughness: 0.95 })
  const [open, setOpen] = useState(false)
  useEffect(() => {
    let alive = true
    const read = () => fetch('/api/jobs', { cache: 'no-store' }).then((r) => r.json()).then((j) => { if (alive) setOpen(!!j?.open) }).catch(() => {})
    read()
    const t = setInterval(read, READ_MS)
    return () => { alive = false; clearInterval(t) }
  }, [])
  // Baked transform: render at identity.
  return <primitive object={scene} visible={open} />
}

export default JobCentre
